module.exports = __webpack_public_path__ + "static/chelan.2113e3fd.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/chelan.png
// module id = 441
// module chunks = 168707334958949